import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, Modal } from '@copilot/ui';
import { useAuth } from '../../hooks/useAuth';
import * as billingApi from '../../services/billingApi';

// Shown after sign-in to a user with no plan at all (entitlement status
// "no_plan" - e.g. they registered while no free plan was available).
// Skippable on purpose: they can still browse; starting a meeting is
// what the backend blocks (NO_ACTIVE_SUBSCRIPTION). Reappears on the
// next sign-in / page load until they pick a plan.
//
// Never shown while a Meeting Pass still grants AI access (Ask KrishvaQ,
// documents, memory search): that user has paid for something usable.
function shouldPromptForPlan(entitlement) {
  return entitlement?.status === 'no_plan' && !entitlement?.ai_access?.enabled;
}

function ChoosePlanModal() {
  const { user } = useAuth();
  // The effect depends on WHO is signed in, not on the user object, which
  // is replaced on every profile refresh and would refetch the entitlement.
  const userId = user?.id;
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!userId) return undefined;
    // A different person must not inherit the previous person's prompt.
    setOpen(false);
    let cancelled = false;

    billingApi
      .getEntitlement()
      .then((entitlement) => {
        if (!cancelled && shouldPromptForPlan(entitlement)) setOpen(true);
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [userId]);

  if (!open) return null;

  return (
    <Modal
      title="Choose a plan to get started"
      subtitle="You don't have an active plan yet. Pick one to start creating meetings."
      size="md"
      onClose={() => setOpen(false)}
      actions={
        <>
          <Button variant="ghost" onClick={() => setOpen(false)}>
            Maybe later
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              setOpen(false);
              navigate('/app/billing/plans');
            }}
          >
            Buy a plan
          </Button>
        </>
      }
    />
  );
}

export default ChoosePlanModal;
